import React from "react";
import { useTranslation } from "react-i18next";
import iconRegister from "../../img/markets/icon-register.svg";
import iconDeposit from "../../img/markets/icon-deposit.svg";
import iconTrade from "../../img/markets/icon-trade.svg";

const STEPS = [
  {
    numKey: "markets.steps.s1.num",
    titleKey: "markets.steps.s1.title",
    descKey: "markets.steps.s1.desc",
    bg: "bg-[#fcefea]",
    numColor: "text-[#ccc]",
    dot: "bg-[#f04e0a]",
    iconBg: "bg-[#ee5414]",
    icon: iconRegister,
    titleColor: "text-[#0a0a0a]",
    descColor: "text-[#888]",
  },
  {
    numKey: "markets.steps.s2.num",
    titleKey: "markets.steps.s2.title",
    descKey: "markets.steps.s2.desc",
    bg: "bg-[#0a0a0a]",
    numColor: "text-[#444]",
    dot: "bg-[#f04e0a]",
    iconBg: "bg-white",
    icon: iconDeposit,
    titleColor: "text-white",
    descColor: "text-[#666]",
  },
  {
    numKey: "markets.steps.s3.num",
    titleKey: "markets.steps.s3.title",
    descKey: "markets.steps.s3.desc",
    bg: "bg-[#f04e0a]",
    numColor: "text-[rgba(255,255,255,0.5)]",
    dot: "bg-white",
    iconBg: "bg-[#0a0a0a]",
    icon: iconTrade,
    titleColor: "text-white",
    descColor: "text-[rgba(255,255,255,0.75)]",
  },
];

function ReadyMoves() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[50px] items-center">
        <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none text-center">
          {t("markets.steps.title")}
        </h2>

        {/* Cards */}
        <div className="flex flex-col xl:grid xl:grid-cols-3 gap-[12px] xl:gap-[20px] w-full">
          {STEPS.map((step, i) => (
            <div key={i} className={`${step.bg} rounded-[20px] relative h-[170px] xl:h-[334px]`}>
              {/* Step number + status dot */}
              <div className="absolute top-[30px] left-[36px] right-[36px] flex items-center justify-between">
                <span className={`font-['Montserrat'] font-bold text-[13px] ${step.numColor} tracking-[1.3px]`}>
                  {t(step.numKey)}
                </span>
                <div className={`${step.dot} rounded-[7px] size-[14px]`} />
              </div>

              {/* Mobile layout: icon left, title+desc right (at top-[66px]) */}
              <div className="xl:hidden absolute top-[66px] left-[36px] right-[36px] flex items-start gap-[20px]">
                <div className={`${step.iconBg} rounded-full size-[52px] flex items-center justify-center shrink-0`}>
                  <img src={step.icon} alt="" className="size-[24px]" />
                </div>
                <div className="flex flex-col gap-[4px]">
                  <span className={`font-['Montserrat'] font-black text-[24px] ${step.titleColor} tracking-[-0.76px] uppercase leading-[38px]`}>
                    {t(step.titleKey)}
                  </span>
                  <span className={`font-['Inter'] font-normal text-[14px] ${step.descColor} leading-[24.75px]`}>
                    {t(step.descKey)}
                  </span>
                </div>
              </div>

              {/* Desktop layout: stacked (icon at top-[104px], title at top-[184px], desc at top-[237px]) */}
              <div className="hidden xl:block">
                <div className="absolute top-[104px] left-[36px]">
                  <div className={`${step.iconBg} rounded-full size-[52px] flex items-center justify-center`}>
                    <img src={step.icon} alt="" className="size-[24px]" />
                  </div>
                </div>
                <div className="absolute top-[184px] left-[36px] right-[36px]">
                  <span className={`font-['Montserrat'] font-black text-[38px] ${step.titleColor} tracking-[-0.76px] uppercase leading-[38px]`}>
                    {t(step.titleKey)}
                  </span>
                </div>
                <div className="absolute top-[237px] left-[36px] right-[36px]">
                  <span className={`font-['Inter'] font-normal text-[18px] ${step.descColor} leading-[24.75px]`}>
                    {t(step.descKey)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ReadyMoves;
